export default [
  {
    path: "/docs",
    component: () => import("./moduleLayout.vue"),
    children: [
      {
        props: true,
        path: ":slug",
        name: "ngo-docs",
        component: () => import("./pages/docs-page/index.vue"),
      },
    ],
  },
];
